import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CssFilterConverter from "css-filter-converter";
import { useContext } from "react";
import GlobalStoreContext from "../../context/GlobalStoreContext";
import Helper from "../../Helper";
import { Area } from "../../models/Area";
import { Dropoff } from "../../models/Dropoff";
import { Equipment } from "../../models/Equipment";
import { Gate } from "../../models/Gate";
import { GateToDropoffRoute } from "../../models/GateToDropoffRoute";
import { HaulRoute } from "../../models/HaulRoute";
import { MapObject } from "../../models/MapObject";
import { iconType } from "../Helper/Map";

type AreaAvatarProps = {
    // Optional when a mapObject is passed - only needed to look the map object up, or for showName.
    mappable?: Area | Dropoff | Equipment | Gate | HaulRoute | GateToDropoffRoute | null;
    // Pass explicitly when the map object isn't in the global store (e.g. the dashboard's raw API
    // data, which has no GlobalStoreContext to look it up from).
    mapObject?: MapObject | null;
    showName?: boolean;
    size?: string;
};

export function AreaAvatar({ mappable, mapObject: mapObjectProp, showName = false, size = "1rem" }: AreaAvatarProps) {
    const context = useContext(GlobalStoreContext);
    const mapObject = mapObjectProp !== undefined ? mapObjectProp : mappable?.getMapObject?.(context);
    if (!mapObject) return null;

    let color = mapObject.color || "#ff9e00";

    if (mapObject.geometry === "lineString") {
        color = mapObject.outline || mapObject.color || "#ff9e00";
    }

    const style = {
        width: size,
        filter: mapObject.icon?.includes("sdf")
            ? (CssFilterConverter.hexToFilter(color).color ?? undefined)
            : undefined,
    };

    const avatar = mapObject.icon ? (
        <img style={style} src={`/img/png/map/${mapObject.icon}.png`} className={showName ? undefined : "mr-2"} />
    ) : (
        <FontAwesomeIcon
            className="mr-2"
            icon={iconType(mapObject.geometry)}
            color={color}
            style={{ width: size, height: size }}
        />
    );

    if (!showName || !mappable) {
        return avatar;
    }

    return (
        <div className={Helper.classNames("flex flex-row items-center gap-2")}>
            {avatar}
            <span>{mappable.name}</span>
        </div>
    );
}

export default AreaAvatar;
